export interface CorporateOnboardingContentDto {
  id: string; // Guid
  sectionName: string;
  title: string;
  content: string; // JSON or HTML string
  instructions?: string | null;
  requiredFields?: string | null;
  displayOrder: number;
  isActive: boolean;
  createdAt: string; // DateTime as ISO string
  updatedAt?: string | null; // DateTime as ISO string
}
